import { Form } from "antd";
import CustomInput from "../CustomInput/Input";
import CustomSelect from "../CustomSelect/CustomSelect"
import FormFooter from "./FormFooter";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { reasonRules } from "../../helpers/helpers";
import { ERROR_MSGS } from "../../constants/constants";

const ReasonForm = ({
    label,
    placeholder,
    btnName,
    btnType,
    submitLoading,
    submitError,
    onClose,
    handleOnFormSubmit,
    options,
    hasSelect
}) => {
    const [form] = Form.useForm();

    return (
        <Form layout="vertical" form={form} onFinish={handleOnFormSubmit}>
            {hasSelect && (
                <CustomSelect
                    label="Expiry Days"
                    name="expiryDays"
                    placeholder="Select Expiry Days"
                    options={options}
                    isRequired={true}
                    rules={[{ required: true, message: ERROR_MSGS.SEL_EXP_DAYS_ERR_MSG }]}
                />
            )}

            <CustomInput
                rows={4}
                name="reason"
                label={label}
                placeholder={placeholder}
                isRequired={true}
                isTextArea={true}
                rules={reasonRules}
            />

            {submitError && <ErrorAlert error={submitError} />}

            <FormFooter
                onCancelClick={() => {
                    onClose();
                    form.resetFields();
                }}
                submitLoading={submitLoading}
                btnType={btnType}
                btnName={btnName}
            />
        </Form>
    );
};

export default ReasonForm;
